"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _wrapper;
  return {
    wrapper: (_wrapper = {
      width: '100%'
    }, (0, _defineProperty2.default)(_wrapper, theme.breakpoints.up('sm'), {
      width: 'calc(50%)'
    }), (0, _defineProperty2.default)(_wrapper, theme.breakpoints.up('md'), {
      width: 'calc(40% - (100% / 24))'
    }), _wrapper),
    inputText: {
      border: "1px solid ".concat(theme.palette.grey['400']),
      padding: '10px',
      borderRadius: '5px',
      width: '100%'
    },
    placeholderWrapper: {
      position: 'relative',
      '& label': {
        fontSize: theme.typography.pxToRem(13),
        color: theme.palette.grey['500'],
        position: 'absolute',
        top: '6px',
        left: '11px',
        pointerEvents: 'none'
      },
      '& input:not([value=""]) + label': {
        opacity: 0
      }
    },
    default: (0, _defineProperty2.default)({
      textAlign: 'center',
      lineHeight: '24.5px',
      marginTop: theme.spacing(6),
      padding: '10px 24px',
      borderRadius: theme.shape.borderRadius,
      fontWeight: theme.typography.fontWeightBold,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(14),
      minWidth: '144px',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      padding: '6px 24px',
      width: 'auto'
    })
  };
});
var isBrowser = typeof window !== 'undefined';
var SiteContentSearch = function SiteContentSearch(_ref) {
  var headline = _ref.headline,
    buttonLabel = _ref.buttonLabel,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    _ref$applications = _ref.applications,
    applications = _ref$applications === void 0 ? [] : _ref$applications;
  var _React$useState = _react.default.useState(''),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    inputValue = _React$useState2[0],
    setInputValue = _React$useState2[1];
  var classes = useStyles();
  var inputReference = (0, _react.useRef)(null);
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var trimmedInput = inputValue.trim();

    // if empty focus in textfield
    if (trimmedInput === '') {
      var _inputReference$curre;
      if (trimmedInput !== inputValue) setInputValue(trimmedInput);
      inputReference === null || inputReference === void 0 ? void 0 : (_inputReference$curre = inputReference.current) === null || _inputReference$curre === void 0 ? void 0 : _inputReference$curre.focus();
      return;
    }
    var searchParams = new URLSearchParams();
    searchParams.set('type', 'site_content');
    searchParams.set('focus', 'sitecontent');
    searchParams.set('term', trimmedInput);
    searchParams.append('facet', 'facet_content_type:Protocol');
    searchParams.append('facet', 'facet_content_type:Technical Article');
    applications.forEach(function (application) {
      searchParams.append('facet', "facet_applications:".concat(application));
    });
    if (isBrowser) {
      var newurl = "".concat(window.location.protocol, "//").concat(window.location.host, "/search/").concat(encodeURIComponent(inputValue), "?").concat(searchParams.toString());
      window.location.href = newurl;
    }
  };
  var handleChange = function handleChange(event) {
    setInputValue(event.target.value);
  };
  var inputId = "sitecontentsearch".concat(Date.now(), "-").concat(Math.floor(Math.random() * 100));
  return __jsx("section", {
    className: (0, _clsx.default)(classes.wrapper, 'aem-ms-cmp')
  }, headline && __jsx("h3", {
    dangerouslySetInnerHTML: {
      __html: headline
    }
  }), __jsx("form", {
    onSubmit: handleSubmit
  }, __jsx("div", {
    className: classes.placeholderWrapper
  }, __jsx("input", {
    className: classes.inputText,
    type: "text",
    id: inputId,
    ref: inputReference,
    value: inputValue,
    onChange: handleChange
  }), __jsx("label", {
    htmlFor: inputId,
    dangerouslySetInnerHTML: {
      __html: placeholder
    }
  })), __jsx(_Box.default, {
    display: "flex",
    alignItems: "center",
    className: "aem-ms-cta"
  }, __jsx("button", {
    className: "aem-ms-cta--button btn-primary ".concat(classes.default),
    type: "submit"
  }, __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: buttonLabel
    }
  })))));
};
var SiteContentSearchEditConfig = {
  emptyLabel: 'Configure Site content search',
  isEmpty: function isEmpty(props) {
    return !props || !props.buttonLabel;
  }
};
var _default2 = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/sitecontentsearch')(SiteContentSearch, SiteContentSearchEditConfig);
exports.default = _default2;